/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Error_Link_Required1Inputs */

const vi_sitesettings_error_link_required1 = /** @type {(inputs: Sitesettings_Error_Link_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn loại đích cho liên kết này.`)
};

/**

* @param {Sitesettings_Error_Link_Required1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_error_link_required1 = /** @type {((inputs?: Sitesettings_Error_Link_Required1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Error_Link_Required1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_error_link_required1(inputs)
});
export { sitesettings_error_link_required1 as "siteSettings_error_link_required" }